// extracted by mini-css-extract-plugin
export var animationContainer = "_nl-0";
export var footer = "_nl-1";
export var gray = "_nl-2";
export var lineItem = "_nl-3";
export var lineItemImage = "_nl-4";
export var lineItemInfo = "_nl-5";
export var lineItemText = "_nl-6";
export var lineItems = "_nl-7";
export var modalContent = "_nl-8";
export var options = "_nl-9";
export var orderName = "_nl-a";
export var refundAmount = "_nl-b";